<template>
  <div class="main-conent main-conent-minheight">
    <el-card shadow="never" class="border-none search">
      <search
        slot="header"
        :day="day"
        :date-count="dateCount"
        :loading-count="loadingCount"
        @change="goSearch"
        @month-change="getDateCount"
        @date-change="dayChange"
      ></search>

      <img-cards
        :data="data"
        :loading="loading"
        @show-model="showModel"
      ></img-cards>

      <div class="margin-t16 text-right">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="total"
          :page-size="limit"
          :current-page="page"
          @current-change="goPage"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
// import showCameraDetail from './camera'
import showScannerDetail from './model'

import ImgCards from './cards'
import Search from './search'
import { getPictures, getDateCount } from '@/service/telemetry'
import { formatDate, add, subtract } from '@/utlis/date'
import sleep from '@/utlis/sleep'
import _ from 'lodash'

export default {
  components: { ImgCards, Search },
  data() {
    return {
      query: {},
      loading: false,
      loadingCount: false,
      searchOpen: false,
      day: '',
      month: '',
      total: 0,
      limit: 21,
      page: 1,
      data: [],
      dateCount: [],
      detail: null
    }
  },
  computed: {
    statisticPrev() {
      return this.$store.getters.statisticPrev
    }
  },
  mounted() {
    this.query = {
      limit: this.limit,
      companyId: this.companyId
    }
    this.getData(this.query)
  },
  methods: {
    async getData(query = {}, devChange) {
      this.loading = true
      if (!query.beginDate) query.beginDate = 'lastDay'
      const [{ data }] = await Promise.all([
        getPictures(+this.companyId, query),
        sleep(1)
      ])
      const { paging, pictures, insects } = data
      this.total = paging.count
      this.page = paging.page
      this.data = _.orderBy(
        pictures.map(p => ({
          ...p,
          insects: insects.filter(i => i.pictureId === p.id && i.qty > 0)
        })),
        'createdAt',
        'desc'
      )

      if (query.beginDate === 'lastDay' && pictures && pictures[0]) {
        this.day = this.initDay(pictures[0])
      }

      if (devChange) {
        this.getDateCount(formatDate(this.day, 'YYYY-MM'))
      }
      this.loading = false
    },
    async getDateCount(month) {
      this.month = month
      this.loadingCount = true
      const [{ data }] = await Promise.all([
        getDateCount(this.query.deviceId, month, this.companyId),
        sleep(0.5)
      ])
      this.loadingCount = false
      this.dateCount = data
    },
    async dayChange(day) {
      let _day = this.statisticPrev ? day : add(day, 1, 'days', 'YYYY-MM-DD')
      this.day = day
      const query = {
        ...this.query,
        beginDate: _day,
        endDate: _day,
        page: 1
      }
      this.getData(query)
      this.query = query
    },
    initDay(pic) {
      const createdAt = new Date(pic.createdAt)
      const hour = createdAt.getHours()
      if (hour >= 8) {
        return add(createdAt, 1, 'days', 'YYYY-MM-DD')
      } else if (!this.statisticPrev) {
        return subtract(createdAt, 1, 'days', 'YYYY-MM-DD')
      } else {
        return formatDate(createdAt, 'YYYY-MM-DD')
      }
    },
    goSearch(query) {
      const devChange = this.query.deviceId !== query.deviceId
      this.query = query
      this.getData(this.getSearch(), devChange)
    },
    goPage(page) {
      let query = this.getSearch()
      if (page > 1) query.page = page
      this.getData(query)
    },
    getSearch() {
      let query = { limit: this.limit }
      Object.keys(this.query).forEach(k => {
        if (this.query[k]) {
          query[k] = this.query[k]
        }
      })
      return query
    },
    showModel(id) {
      showScannerDetail({ id, query: this.query })
    }
  }
}
</script>
